import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { PromoAdjustmentUnit } from '../types/promotion.types';

export const DEFAULT_PROMOTION_PAGE_SIZE = 50;

interface PromoAdjustmentUnitDisplay {
  hasDetailedInstituteCells: boolean;
  amountUnit: string | undefined;
  memberAmountHeader: string;
  instituteAmountHeader: string;
  memberWorkHeader: string;
  memberAreaHeader: string;
  instituteAreaHeader: string;
}

export const PROMO_ADJUSTMENT_UNIT_DISPLAY: Record<
  PromoAdjustmentUnit,
  PromoAdjustmentUnitDisplay
> = {
  promotion: {
    hasDetailedInstituteCells: false,
    amountUnit: undefined,
    memberAmountHeader: 'Distributed',
    instituteAmountHeader: 'Qty',
    memberWorkHeader: 'Department, Designation',
    memberAreaHeader: 'HR Division, District, Thana',
    instituteAreaHeader: 'Institute Division, District, Thana',
  },
  marketPromotion: {
    hasDetailedInstituteCells: true,
    amountUnit: TAKA_SYMBOL,
    memberAmountHeader: 'Distributed (Tk)',
    instituteAmountHeader: 'Amount (Tk)',
    memberWorkHeader: 'Department / Designation',
    memberAreaHeader: 'Area',
    instituteAreaHeader: 'Institute Area',
  },
};

export const LOOKUP_PAGE_SIZE = 200;

export const ALL_ROWS_LOOKUP_PARAMS = { page: 1, pageSize: LOOKUP_PAGE_SIZE } as const;

export const ACTIVE_ROWS_LOOKUP_PARAMS = {
  page: 1,
  pageSize: LOOKUP_PAGE_SIZE,
  isActive: true,
} as const;
